module.exports = __webpack_public_path__ + "img/snake.a4a19fb3.jpg";